import { createElement } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const main = () => {
  const app = createElement(App, {});
  const host = document.getElementById("host");
  if (host) {
    const root = createRoot(host);
    root.render(app);
  }
};
main();
